import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "providers/Auth";
import { FEATURES } from "types/landlord/partner";
import { boomFinanceApi } from "api/boom-finance/api";

export const LENDERS_QUERY_KEY = ["BOOM_FINANCE_LENDERS"];

export const lendersQueryKey = ({ enabledOnly = false } = {}) => [
  ...LENDERS_QUERY_KEY,
  { enabledOnly }
];

export const useFinanceLenders = ({
  enabledOnly = false
}: { enabledOnly?: boolean } = {}) => {
  const { partner } = useAuthContext();

  return useQuery({
    queryKey: lendersQueryKey({ enabledOnly }),
    queryFn: () => boomFinanceApi.getLenders({ enabledOnly }),
    enabled: Boolean(partner?.features.includes(FEATURES.WIP_BOOM_FINANCE))
  });
};
